import { render, staticRenderFns } from "./FacetsFilters.vue?vue&type=template&id=31a22784&"
import script from "./FacetsFilters.vue?vue&type=script&lang=ts&"
export * from "./FacetsFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports